import ChargeStationBingMapView2 from '../../components/ChargeStationBingMapView2';

ChargeStationIframeMapScreen.propTypes = {};

function ChargeStationIframeMapScreen(props) {
  return (
    <div className="container-fluid px-0">
      <ChargeStationBingMapView2 iframeMode={true} />
    </div>
  );
}

export default ChargeStationIframeMapScreen;
